export const logoutUser = () => {
    localStorage.clear()
    window.location.href = '/'
}

export const getOrdinalSuffix = (value) => {
    const number = parseInt(value, 10);
    if (Number.isNaN(number)) return "th";
    const lastTwo = number % 100;
    if (lastTwo >= 11 && lastTwo <= 13) return "th";
    const last = number % 10;
    if (last === 1) return "st";
    if (last === 2) return "nd";
    if (last === 3) return "rd";
    return "th";
};